import { render, staticRenderFns } from "./ValidDialog.vue?vue&type=template&id=84968626&"
import script from "./ValidDialog.vue?vue&type=script&lang=js&"
export * from "./ValidDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports